module.exports = __webpack_public_path__ + "static/media/nextjs.e89430dc.svg";